import { createField } from "./cancel-sequestrate-info.section";
import lodash from "lodash";
import { createForm as createFormAddress } from "../../../../../../components/address/address.logic";

export const initForm = ({ props, data, refs }) => {
    const key = props.dataKey;
    const isLoading = props.isLoading;
    const model = initDefaultForm({ props, data, key });
    data.fields = createField({ props, data, refs, key, isLoading });

    if (model.id) {
        data.products = {
            fetchCriteria: {
                select: ["**",
                    "refReleaseProduct.refInspectionProduct.refInformProduct.refHazObject.id",
                    "refReleaseProduct.refInspectionProduct.refInformProduct.refHazObject.nameTh",
                    "refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.id",
                    "refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.refSubStanceTypeMain.value",
                    "refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.tradeNameTh",
                    "refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.approveCode",
                ],
                page: 0,
                size: 1000000,
                where: [{ name: "refCancelSequestrate.id", type: "UUID", operator: "=", value: model.id }],
                sort: [{ name: "createDate", type: "ASC" }],
            }
        };
    }
};

export const createForm = () => {
    const form = {
        refDepartment: null,
        refUserCompany: null,
        refUser: null,
        approveCode: null,
        effectiveDate: null,
        expireDate: null,
        refStatus: null,
        refSequestrate: null,
        cancelSequestrateDate: null,
        regulation: null,
        customer: null,
        openInspector: null,
        refResult: null,
        cause: null,
        activity: null,
        followDetail: null,
        products: [],
        attachments: [],
        addresses: [],
    };
    return form;
};

export const initDefaultForm = ({ data, key }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    if (!model?.addresses?.length) {
        model.addresses = [{ ...createFormAddress(), refAddressType: lodash.cloneDeep(data.addressTypes?.find(d => d.key === "1"))}];
    }
    if (data.addressTypes && model?.addresses?.length && !model.addresses[0].refAddressType) {
        model.addresses[0].refAddressType = lodash.cloneDeep(data.addressTypes.find(d => d.key === "1"));
    }
    return model;
}